// Routes de l'option « Ma gamme » (activée par l'éditeur ; sans elle, l'écran le dit et le serveur refuse).
import type { RouteObject } from 'react-router';
import '../../styles/gamme.css';
import { PageGamme } from './PageGamme.tsx';
import { PageProduit } from './PageProduit.tsx';

export const routesGamme: RouteObject[] = [
  { path: 'gamme', element: <PageGamme /> },
  { path: 'gamme/:id', element: <PageProduit /> },
];
